// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.league-match-report__container {
    display: grid;
    grid-template-columns: repeat(10, 1fr);
    border-radius: var( --space-half );
    padding-bottom: var( --space-x2 );
}

.league-match-report {
    grid-column: 1 / 11;
}

.league-match-report__header {
    display: flex;
    align-items: center;
    margin: calc( var( --space-and-half ) + var( --space-quarter ) ) 0;
}

.league-match-report__header .baloa-headline-2 {
    color: var( --primary-very-dark-color );
}

.league-match-report__header .icon-arrow-left{
    cursor: pointer;
}

.league-match-report__header .icon-arrow-left {
    font-size: calc( var( --space-and-half ) - 2px );
    margin-right: calc( var( --space-and-half ) + var( --space-quarter ) );
}

.league-match-report__own-goal {
    display: flex;
    align-items: center;
}

.league-match-report__own-goal .baloa-body-2 {
    color: var( --error-color ) !important;
}

.league-match-report__own-goal .icon-ball{
    color: var( --error-color );    
}

.league-match-report__icon-ball {
    margin: 0 var(--space);
}

.league-match-report__username .baloa-names {
    color: var( --primary-dark-color );
    margin-bottom: var(--space-eighth);
}

.league-match-report__username .baloa-username {
    color: var( --basic-gray-color );
}

.league-match-report__changes__player-info__names .baloa-names {
    color: var( --primary-dark-color );
    margin-bottom: var(--space-eighth);
}

.league-match-report__changes__player-info__names .baloa-username {
    color: var( --basic-gray-color );
}

.Red_Card {
    background-color: var(--error-color);
}

.Blue_Card {
    background-color: #0273FF;
}

.Yellow_Card {
    background-color: #F1FF51;    
} 

.Double_Yellow_Card { 
    box-shadow: -3px 4px 0px 1px #DBEB1D;
    background-color: var(--error-color);
    margin-bottom: var(--space-quarter);
}

.penalty-card {
    width: 30px;
    height: 20px;
    border-radius: 1px;
    margin: 0 var(--space);
}

.league-match-report__comments-title.baloa-subtitle-2 {
    justify-content: flex-start;
    margin-bottom: calc( var( --space ) + var( --space-eighth ) );
    color: var(--primary-very-dark-color);
}

.league-match-report__match-player-title.baloa-subtitle-2 {
    justify-content: flex-start;
    margin-bottom: calc( var( --space ) + var( --space-eighth ) );
    color: var(--primary-very-dark-color);
}

.league-match-report__results-container {
    background: var(--white-color);
    border-radius: var(--space-half);
    padding: var(--space-x2) 0;
    width: 70%;
}

.league-match-report__local-team__info.username {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.league-match-report__local-visitant__info.username {
    display: flex;
    align-items: center;
    
}

.league-match-report__local-team__info,
.league-match-report__visitant-team__info {
    width: 100%;
}

.league-match-report__local-team,
.league-match-report__visitant-team {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.league-match-report__visitant-team__info.username {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.league-match-report__visitant-team__info {
    justify-content: flex-end;
    display: flex;
}

.league-match-report__own-goal {
    color: var(--error-color);
}

.league-match-report__local-team__info {
    display: flex;
    align-items: center;
}

.league-match-report__local-team__info .league-match-report__username {
    text-align: right;
    margin-right: var(--space-half);
}

.league-match-report__icon-ball {
    font-size: var(--space-and-half);
}

.league-match-report__local-team__info.username .icon-ball,
.league-match-report__visitant-team__info.username .icon-ball,
.league-match-report__changes-list__local .icon-ball,
.league-match-report__changes-list__visitant .icon-ball,
.league-match-report__match-player__info .icon-ball {
    color: var( --white-color );
    font-size: var( --space-x2 );
    border-radius: 50%;
    padding: var( --space-quarter );
}

.league-match-report__local-team__info .baloa-table-column,
.league-match-report__visitant-team__info .baloa-table-column,
.baloa-table-column.league-match-report__changes-list__info {
    color: var(--primary-dark-color);
}

.league-match-report__visitant-team__info .league-match-report__username {
    margin-left: var(--space-half);
}

.league-match-report__local-team__info.username img,
.league-match-report__visitant-team__info.username img,
.league-match-report__changes-list__local img,
.league-match-report__changes-list__visitant img,
.league-match-report__match-player__info img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

.league-match-report__vertical-line {
    width: 0;
    height: 48px;
    border: solid 1px var(--new-gray-background-color);
}

.league-match-report__local-team__container,
.league-match-report__visitant-team__container,
.league-match-report__changes-list__container,
.league-match-report__local-penalty__container,
.league-match-report__visitant-penalty__container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.league-match-report__visitant-team__info .baloa-body-2 {
    margin-left: var(--space-half);
    color: var(--error-color) !important;
}

.league-match-report__local-team__info .baloa-body-2 {
    margin-right: var(--space-half);
    color: var(--error-color) !important;
}

.league-match-report__changes-list {
    display: flex;
    align-items: center;
    width: 100%;
}

.league-match-report__changes-list__info {
    width: 100%;
}

.league-match-report__changes-list__local {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.league-match-report__changes-list__visitant {
    display: flex;
    align-items: center;    
}

.league-match-report__changes-list__local:first-of-type,
.league-match-report__changes-list__visitant:first-of-type {
    margin-bottom: var(--space);
}

.league-match-report__changes-list__visitant .league-match-report__changes__player-info__names {
    margin-left: var(--space-half);
}

.league-match-report__changes-list__arrows {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 75px;
    margin: 0 var(--space);
}

.league-match-report__changes-list__arrows .icon-arrow-right {
    background-color: var(--new-green-color);
    border-radius: 50%;
    font-weight: var(--font-bold);
    color: var(--white-color);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    padding: 4px;
}

.league-match-report__changes-list__arrows .icon-arrow-left {
    background-color: var(--error-color);
    border-radius: 50%;
    font-weight: var(--font-bold);
    color: var(--white-color);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    padding: 4px;
}

.league-match-report__changes-list__local .league-match-report__changes__player-info__names {
    text-align: right;
    margin-right: var(--space-half);
}

.league-match-report__changes-list__info.visitant {
    text-align: right;
}

.league-match-report__comments-container, 
.league-match-report__match-player-container,
.league-match-report__assistance__container_inf {
    background-color: var(--white-color);
    border-radius: var(--space-half);
    padding: var(--space-and-half);
}

.league-match-report__assistance__container{
    margin-bottom: 12px;
}

.league-match-report__assistance__container_inf .baloa-subtitle-2{
    margin-bottom: var(--space-and-half);
}

.league-match-report__match-player-container{
    margin-top: 12px;
}

.league-match-report__comments-container .baloa-table {
    color: var(--primary-very-dark-color);
}

.league-match-report__comments-container .baloa-normal {
    text-align: center;
    color: var(--primary-dark-color);
    margin-bottom: var(--space);
}

.league-match-report__local-scorer:last-of-type .league-match-report__vertical-line,
.league-match-report__visitant-scorer:last-of-type .league-match-report__vertical-line,
.league-match-report__local-change:last-of-type .league-match-report__vertical-line,
.league-match-report__visitant-change:last-of-type .league-match-report__vertical-line,
.league-match-report__local-penalty:last-of-type .league-match-report__vertical-line,
.league-match-report__visitant-penalty:last-of-type .league-match-report__vertical-line {
    display: none;
}

.league-match-report__vertical-line__container {
    display: flex;
    justify-content: center
}

.league-match-report__results {
    display: flex;
}

.league-match-report__payments-comments__container {
    width: 30%;
    margin-left: var(--space-half-quarter);
}

.league-match-report__payments-comments__container .league-match-report__match-payments {
    width: 100%;
    margin-bottom: var(--space-half-quarter);
}

.league-match-report__payments-comments__container .league-match-report__match-payments .button {
    width: 100%;
}

.league-match-report__match-payments,
.league-match-report__match-assistance {
    display: flex;
    flex-direction: column;
    background-color: var(--white-color);
    width: fit-content;
    padding: var(--space-and-half) var(--space-x2);
    border-radius: var(--space-half);
}

.league-match-report__match-payments .baloa-subtitle-2 ,
.league-match-report__match-assistance .baloa-subtitle-2{
    color: var(--primary-very-dark-color);
    margin-bottom: var(--space-and-half);
}

.league-match-report__match-payments .button,
.league-match-report__match-assistance .button,
.league-match-report__assistance__container_inf .button {
    width: 276px;
    grid-template-columns: none;
    grid-template-areas: none;
    background: rgba(48, 179, 107, 0.1);
    border: 2px solid rgba(48, 179, 107, 0.5);
    text-transform: inherit;
}

.league-match-report__assistance__container_inf .button {
    width: 100%;
}


.league-match-report__match-payments .button:hover,
.league-match-report__match-assistance .button:hover{
    background-color: var(--new-green-color);
}

.container-match-report .league-match-report__match-assistance{
    margin-top: var(--space);
}

.league-match-report__header__share-button.small{
    justify-self: flex-end;
    padding: 10px 12px;
    margin-left: auto;
}

.league-match-report__header__share-button .hubicon-share_v2{
    grid-area: icon;
    color: var(--new-green-color);
    margin-right: 8px;
}

.league-match-report__header__share-button:hover .hubicon-share_v2,
.league-match-report__header__share-button:focus .hubicon-share_v2{
    color: var(--white-color);
}

.league-match-report__match-player__info{
    display: flex;
    align-items: center;
    gap: 5px;
}

.league-match-report__match-player__info .baloa-normal-medium{
    color: var(--primary-very-dark-color);
}

.league-match-report__match-player__info .baloa-table{
    color: var(--primary-dark-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ 
    .league-tournament-report__event-container .league-match-report__header{
        margin: var(--space-x2) var(--space) !important;
    }

    .league-match-report__local-team__info.username img,
    .league-match-report__visitant-team__info.username img,
    .league-match-report__changes-list__local img,
    .league-match-report__changes-list__visitant img,
    .league-match-report__match-player__info img {
        width: 18px;
        height: 18px;
    }

    .league-match-report__local-team__info.username .icon-ball,
    .league-match-report__visitant-team__info.username .icon-ball,
    .league-match-report__changes-list__local .icon-ball,
    .league-match-report__changes-list__visitant .icon-ball,
    .league-match-report__match-player__info .icon-ball {
        font-size: var(--space);
        padding: var(--space-quarter);
    }

    .penalty-card {
        width: 20px;
        height: 14px;
    }

    .league-tournament-report__phases__list .MuiInputBase-root {
        font-size: var(--space);
        line-height: unset;
    }

    .league-match-report__changes-list__arrows .icon-arrow-right,
    .league-match-report__changes-list__arrows .icon-arrow-left {
        font-size: calc( var(--space-half) + 2px );
        padding: 0;
        width: 18px;
        height: 18px;
    }

    .league-match-report__results-container,
    .league-match-report__comments-container,
    .league-match-report__match-player-container{    
        margin: var(--space) 0 0 0;
    }

    .league-match-report__results-container {
        width: 100%;
    }

    .hubicon-share_v2{
        color: var(--new-green-color);
        font-size: 16px;
        margin-left: auto;
        cursor: pointer;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-match-report-component/LeagueMatchReportComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sCAAsC;IACtC,kCAAkC;IAClC,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kEAAkE;AACtE;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gDAAgD;IAChD,sEAAsE;AAC1E;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;IAClC,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IAEI,oCAAoC;IACpC,oCAAoC;IACpC,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,6DAA6D;IAC7D,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;IAC3B,6DAA6D;IAC7D,qCAAqC;AACzC;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,0BAA0B;IAC1B,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;;AAEvB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;;;;IAKI,2BAA2B;IAC3B,4BAA4B;IAC5B,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;;;IAGI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;;;;IAKI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,QAAQ;IACR,YAAY;IACZ,kDAAkD;AACtD;;AAEA;;;;;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,+BAA+B;IAC/B,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,wCAAwC;IACxC,kBAAkB;IAClB,6BAA6B;IAC7B,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,6BAA6B;IAC7B,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;;IAGI,oCAAoC;IACpC,gCAAgC;IAChC,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;;;;;;IAMI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,wCAAwC;AAC5C;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,oCAAoC;IACpC,kBAAkB;IAClB,8CAA8C;IAC9C,gCAAgC;AACpC;;AAEA;;IAEI,qCAAqC;IACrC,oCAAoC;AACxC;;AAEA;;;IAGI,YAAY;IACZ,2BAA2B;IAC3B,yBAAyB;IACzB,mCAAmC;IACnC,yCAAyC;IACzC,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;;AAGA;;IAEI,wCAAwC;AAC5C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;AACpC;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,+CAA+C;IACnD;;IAEA;;;;;QAKI,WAAW;QACX,YAAY;IAChB;;IAEA;;;;;QAKI,uBAAuB;QACvB,6BAA6B;IACjC;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,uBAAuB;QACvB,kBAAkB;IACtB;;IAEA;;QAEI,0CAA0C;QAC1C,UAAU;QACV,WAAW;QACX,YAAY;IAChB;;IAEA;;;QAGI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,6BAA6B;QAC7B,eAAe;QACf,iBAAiB;QACjB,eAAe;IACnB;AACJ","sourcesContent":[".league-match-report__container {\n    display: grid;\n    grid-template-columns: repeat(10, 1fr);\n    border-radius: var( --space-half );\n    padding-bottom: var( --space-x2 );\n}\n\n.league-match-report {\n    grid-column: 1 / 11;\n}\n\n.league-match-report__header {\n    display: flex;\n    align-items: center;\n    margin: calc( var( --space-and-half ) + var( --space-quarter ) ) 0;\n}\n\n.league-match-report__header .baloa-headline-2 {\n    color: var( --primary-very-dark-color );\n}\n\n.league-match-report__header .icon-arrow-left{\n    cursor: pointer;\n}\n\n.league-match-report__header .icon-arrow-left {\n    font-size: calc( var( --space-and-half ) - 2px );\n    margin-right: calc( var( --space-and-half ) + var( --space-quarter ) );\n}\n\n.league-match-report__own-goal {\n    display: flex;\n    align-items: center;\n}\n\n.league-match-report__own-goal .baloa-body-2 {\n    color: var( --error-color ) !important;\n}\n\n.league-match-report__own-goal .icon-ball{\n    color: var( --error-color );    \n}\n\n.league-match-report__icon-ball {\n    margin: 0 var(--space);\n}\n\n.league-match-report__username .baloa-names {\n    color: var( --primary-dark-color );\n    margin-bottom: var(--space-eighth);\n}\n\n.league-match-report__username .baloa-username {\n    color: var( --basic-gray-color );\n}\n\n.league-match-report__changes__player-info__names .baloa-names {\n    color: var( --primary-dark-color );\n    margin-bottom: var(--space-eighth);\n}\n\n.league-match-report__changes__player-info__names .baloa-username {\n    color: var( --basic-gray-color );\n}\n\n.Red_Card {\n    background-color: var(--error-color);\n}\n\n.Blue_Card {\n    background-color: #0273FF;\n}\n\n.Yellow_Card {\n    background-color: #F1FF51;    \n} \n\n.Double_Yellow_Card {\n    -webkit-box-shadow: 6px 8px 0px 1px #DBEB1D; \n    box-shadow: -3px 4px 0px 1px #DBEB1D;\n    background-color: var(--error-color);\n    margin-bottom: var(--space-quarter);\n}\n\n.penalty-card {\n    width: 30px;\n    height: 20px;\n    border-radius: 1px;\n    margin: 0 var(--space);\n}\n\n.league-match-report__comments-title.baloa-subtitle-2 {\n    justify-content: flex-start;\n    margin-bottom: calc( var( --space ) + var( --space-eighth ) );\n    color: var(--primary-very-dark-color);\n}\n\n.league-match-report__match-player-title.baloa-subtitle-2 {\n    justify-content: flex-start;\n    margin-bottom: calc( var( --space ) + var( --space-eighth ) );\n    color: var(--primary-very-dark-color);\n}\n\n.league-match-report__results-container {\n    background: var(--white-color);\n    border-radius: var(--space-half);\n    padding: var(--space-x2) 0;\n    width: 70%;\n}\n\n.league-match-report__local-team__info.username {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.league-match-report__local-visitant__info.username {\n    display: flex;\n    align-items: center;\n    \n}\n\n.league-match-report__local-team__info,\n.league-match-report__visitant-team__info {\n    width: 100%;\n}\n\n.league-match-report__local-team,\n.league-match-report__visitant-team {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n}\n\n.league-match-report__visitant-team__info.username {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.league-match-report__visitant-team__info {\n    justify-content: flex-end;\n    display: flex;\n}\n\n.league-match-report__own-goal {\n    color: var(--error-color);\n}\n\n.league-match-report__local-team__info {\n    display: flex;\n    align-items: center;\n}\n\n.league-match-report__local-team__info .league-match-report__username {\n    text-align: right;\n    margin-right: var(--space-half);\n}\n\n.league-match-report__icon-ball {\n    font-size: var(--space-and-half);\n}\n\n.league-match-report__local-team__info.username .icon-ball,\n.league-match-report__visitant-team__info.username .icon-ball,\n.league-match-report__changes-list__local .icon-ball,\n.league-match-report__changes-list__visitant .icon-ball,\n.league-match-report__match-player__info .icon-ball {\n    color: var( --white-color );\n    font-size: var( --space-x2 );\n    border-radius: 50%;\n    padding: var( --space-quarter );\n}\n\n.league-match-report__local-team__info .baloa-table-column,\n.league-match-report__visitant-team__info .baloa-table-column,\n.baloa-table-column.league-match-report__changes-list__info {\n    color: var(--primary-dark-color);\n}\n\n.league-match-report__visitant-team__info .league-match-report__username {\n    margin-left: var(--space-half);\n}\n\n.league-match-report__local-team__info.username img,\n.league-match-report__visitant-team__info.username img,\n.league-match-report__changes-list__local img,\n.league-match-report__changes-list__visitant img,\n.league-match-report__match-player__info img {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n}\n\n.league-match-report__vertical-line {\n    width: 0;\n    height: 48px;\n    border: solid 1px var(--new-gray-background-color);\n}\n\n.league-match-report__local-team__container,\n.league-match-report__visitant-team__container,\n.league-match-report__changes-list__container,\n.league-match-report__local-penalty__container,\n.league-match-report__visitant-penalty__container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.league-match-report__visitant-team__info .baloa-body-2 {\n    margin-left: var(--space-half);\n    color: var(--error-color) !important;\n}\n\n.league-match-report__local-team__info .baloa-body-2 {\n    margin-right: var(--space-half);\n    color: var(--error-color) !important;\n}\n\n.league-match-report__changes-list {\n    display: flex;\n    align-items: center;\n    width: 100%;\n}\n\n.league-match-report__changes-list__info {\n    width: 100%;\n}\n\n.league-match-report__changes-list__local {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.league-match-report__changes-list__visitant {\n    display: flex;\n    align-items: center;    \n}\n\n.league-match-report__changes-list__local:first-of-type,\n.league-match-report__changes-list__visitant:first-of-type {\n    margin-bottom: var(--space);\n}\n\n.league-match-report__changes-list__visitant .league-match-report__changes__player-info__names {\n    margin-left: var(--space-half);\n}\n\n.league-match-report__changes-list__arrows {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    height: 75px;\n    margin: 0 var(--space);\n}\n\n.league-match-report__changes-list__arrows .icon-arrow-right {\n    background-color: var(--new-green-color);\n    border-radius: 50%;\n    font-weight: var(--font-bold);\n    color: var(--white-color);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    padding: 4px;\n}\n\n.league-match-report__changes-list__arrows .icon-arrow-left {\n    background-color: var(--error-color);\n    border-radius: 50%;\n    font-weight: var(--font-bold);\n    color: var(--white-color);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    padding: 4px;\n}\n\n.league-match-report__changes-list__local .league-match-report__changes__player-info__names {\n    text-align: right;\n    margin-right: var(--space-half);\n}\n\n.league-match-report__changes-list__info.visitant {\n    text-align: right;\n}\n\n.league-match-report__comments-container, \n.league-match-report__match-player-container,\n.league-match-report__assistance__container_inf {\n    background-color: var(--white-color);\n    border-radius: var(--space-half);\n    padding: var(--space-and-half);\n}\n\n.league-match-report__assistance__container{\n    margin-bottom: 12px;\n}\n\n.league-match-report__assistance__container_inf .baloa-subtitle-2{\n    margin-bottom: var(--space-and-half);\n}\n\n.league-match-report__match-player-container{\n    margin-top: 12px;\n}\n\n.league-match-report__comments-container .baloa-table {\n    color: var(--primary-very-dark-color);\n}\n\n.league-match-report__comments-container .baloa-normal {\n    text-align: center;\n    color: var(--primary-dark-color);\n    margin-bottom: var(--space);\n}\n\n.league-match-report__local-scorer:last-of-type .league-match-report__vertical-line,\n.league-match-report__visitant-scorer:last-of-type .league-match-report__vertical-line,\n.league-match-report__local-change:last-of-type .league-match-report__vertical-line,\n.league-match-report__visitant-change:last-of-type .league-match-report__vertical-line,\n.league-match-report__local-penalty:last-of-type .league-match-report__vertical-line,\n.league-match-report__visitant-penalty:last-of-type .league-match-report__vertical-line {\n    display: none;\n}\n\n.league-match-report__vertical-line__container {\n    display: flex;\n    justify-content: center\n}\n\n.league-match-report__results {\n    display: flex;\n}\n\n.league-match-report__payments-comments__container {\n    width: 30%;\n    margin-left: var(--space-half-quarter);\n}\n\n.league-match-report__payments-comments__container .league-match-report__match-payments {\n    width: 100%;\n    margin-bottom: var(--space-half-quarter);\n}\n\n.league-match-report__payments-comments__container .league-match-report__match-payments .button {\n    width: 100%;\n}\n\n.league-match-report__match-payments,\n.league-match-report__match-assistance {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--white-color);\n    width: fit-content;\n    padding: var(--space-and-half) var(--space-x2);\n    border-radius: var(--space-half);\n}\n\n.league-match-report__match-payments .baloa-subtitle-2 ,\n.league-match-report__match-assistance .baloa-subtitle-2{\n    color: var(--primary-very-dark-color);\n    margin-bottom: var(--space-and-half);\n}\n\n.league-match-report__match-payments .button,\n.league-match-report__match-assistance .button,\n.league-match-report__assistance__container_inf .button {\n    width: 276px;\n    grid-template-columns: none;\n    grid-template-areas: none;\n    background: rgba(48, 179, 107, 0.1);\n    border: 2px solid rgba(48, 179, 107, 0.5);\n    text-transform: inherit;\n}\n\n.league-match-report__assistance__container_inf .button {\n    width: 100%;\n}\n\n\n.league-match-report__match-payments .button:hover,\n.league-match-report__match-assistance .button:hover{\n    background-color: var(--new-green-color);\n}\n\n.container-match-report .league-match-report__match-assistance{\n    margin-top: var(--space);\n}\n\n.league-match-report__header__share-button.small{\n    justify-self: flex-end;\n    padding: 10px 12px;\n    margin-left: auto;\n}\n\n.league-match-report__header__share-button .hubicon-share_v2{\n    grid-area: icon;\n    color: var(--new-green-color);\n    margin-right: 8px;\n}\n\n.league-match-report__header__share-button:hover .hubicon-share_v2,\n.league-match-report__header__share-button:focus .hubicon-share_v2{\n    color: var(--white-color);\n}\n\n.league-match-report__match-player__info{\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.league-match-report__match-player__info .baloa-normal-medium{\n    color: var(--primary-very-dark-color);\n}\n\n.league-match-report__match-player__info .baloa-table{\n    color: var(--primary-dark-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ \n    .league-tournament-report__event-container .league-match-report__header{\n        margin: var(--space-x2) var(--space) !important;\n    }\n\n    .league-match-report__local-team__info.username img,\n    .league-match-report__visitant-team__info.username img,\n    .league-match-report__changes-list__local img,\n    .league-match-report__changes-list__visitant img,\n    .league-match-report__match-player__info img {\n        width: 18px;\n        height: 18px;\n    }\n\n    .league-match-report__local-team__info.username .icon-ball,\n    .league-match-report__visitant-team__info.username .icon-ball,\n    .league-match-report__changes-list__local .icon-ball,\n    .league-match-report__changes-list__visitant .icon-ball,\n    .league-match-report__match-player__info .icon-ball {\n        font-size: var(--space);\n        padding: var(--space-quarter);\n    }\n\n    .penalty-card {\n        width: 20px;\n        height: 14px;\n    }\n\n    .league-tournament-report__phases__list .MuiInputBase-root {\n        font-size: var(--space);\n        line-height: unset;\n    }\n\n    .league-match-report__changes-list__arrows .icon-arrow-right,\n    .league-match-report__changes-list__arrows .icon-arrow-left {\n        font-size: calc( var(--space-half) + 2px );\n        padding: 0;\n        width: 18px;\n        height: 18px;\n    }\n\n    .league-match-report__results-container,\n    .league-match-report__comments-container,\n    .league-match-report__match-player-container{    \n        margin: var(--space) 0 0 0;\n    }\n\n    .league-match-report__results-container {\n        width: 100%;\n    }\n\n    .hubicon-share_v2{\n        color: var(--new-green-color);\n        font-size: 16px;\n        margin-left: auto;\n        cursor: pointer;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
